import React, {useEffect,useState} from 'react'
import {FormField,Select} from 'grommet'
import { Organization } from 'grommet-icons';
import {APIRequest} from './utils/shared/requests'

function OrgsDropdown(props) {
    const [org, setOrg] = useState();
    const [orgs, setOrgs] = useState([]);
        useEffect(() => {    
          APIRequest('/organisations').then(result => setOrgs(result))
          if (props.org){
            setOrg(props.org)
            props.setOrg(props.org)
          } else {
            setOrg({})
          }
         },[]);
        //  useEffect(() => {setOrg(props.org)},[props.org])
  return (
    <FormField required name="organisation" label="Organisation" margin='small'>
      <Select required icon={<Organization />}name='organisation' placeholder={'Please Select Organisation'} options={orgs} value={org} labelKey="name" valueKey="id" onChange={({ option }) => {setOrg(option); props.setOrg(option)}}/>
    </FormField>
  )
}

export default OrgsDropdown
